<template>
  <div class="course-detail">
    <div class="course-detail-main">
      <div class="location">
        <img :src="require('../../assets/img/location.png')" alt="">
        当前位置：
        <template v-for="(item, index) in pathList">
          <span :key="index" class="location-name" @click="$router.push(item.path)">{{ item.name }}  </span> >
        </template>
        课程详情
      </div>
      <div class="course-content">
        <img v-if="detailData.coverImg" :src="$urlPrefix + detailData.coverImg" alt="">
        <div v-else class="coverArea" style="width: 362px;height: 252px">
          <p style="font-size: 20px;line-height: 35px">{{ detailData.courseTitle }}</p>
        </div>
        <div class="detail-info">
          <div class="title">
            {{ detailData.courseTitle }}
          </div>
          <div class="gray-area">
            <p class="time">发布时间: &nbsp;&nbsp;{{ detailData.inputTime }}</p>
            <p class="bottom">
              浏览量:&nbsp;&nbsp;<span>{{ detailData.pageView }}人</span>
            </p>
          </div>
        </div>
        <div style="margin-top: 30px;text-align: initial" v-html="detailData.courseContent" />
        <div class="toJoin" @click="toJoin(detailData.skipLink)">立即报名</div>
      </div>
      <template v-if="tutorList && tutorList.length > 0">
        <p class="tutor">导师阵容</p>
        <div v-for="(item, index) in tutorList" :key="index" class="tutor-item">
          <img :src="item.headImg ? $urlPrefix + item.headImg : require('../../assets/img/defaultHead2.png')" alt="">
          <div class="tutor-detail">
            <span @click="checkTutor(item.pkid)">{{ item.tutorName }}</span><br>
            {{ item.tutorProfile }}
          </div>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CourseDetail',
  data() {
    return {
      pathList: [],
      currentPathList: [],
      tutorList: [],
      detailData: {},
      fromPath: {
        topName: '',
        topPath: '',
        path: '',
        name: ''
      }
    }
  },
  created() {
    if (this.$route.query.pathList) {
      this.pathList = JSON.parse(this.$route.query.pathList)
      this.pathList = this.pathList.filter(item => item.name !== '课程详情')
      this.currentPathList = JSON.stringify([...this.pathList, {
        name: '课程详情',
        path: this.$route.fullPath
      }])
    }
    this.fetchData()
  },
  methods: {
    fetchData() {
      this.$get('/front/index/courseInfo', this.$route.query.pkid).then(res => {
        if (res) {
          this.detailData = res
          this.tutorList = res.tutorList
        }
      })
    },
    checkTutor(pkid) {
      this.$router.push({
        path: '/tutorDetail',
        query: {
          pkid: pkid,
          pathList: this.currentPathList
        }
      })
    },
    toJoin(link) {
      window.open(link, '_blank')
    }
  }
}
</script>

<style lang="scss" scoped>
.course-detail {
  background-color: #F6F6F5;
  padding: 30px 0;
  .course-detail-main {
    width: 1200px;
    margin: 0 auto;
    .location {
      width: 1200px;
      font-size: 14px;
      font-weight: 400;
      color: #363942;
      margin: 0 auto 25px auto;
      img {
        vertical-align: middle;
        margin-right: 10px;
      }
      .location-name {
        cursor: pointer;
        color: darkgray;
      }
      .location-name:hover {
        color: #EA5504;
      }
    }
    .course-content {
      position: relative;
      width: 1200px;
      background-color: #FFFFFF;
      padding: 30px;
      overflow: hidden;
      box-sizing: border-box;
      img {
        display: inline-block;
        width: 362px;
        height: 252px;
        border-radius: 6px;
        vertical-align: top;
      }
      .detail-info {
        display: inline-block;
        width: 755px;
        margin-left: 20px;
        .title {
          display: -webkit-box;
          width: 750px;
          height: 70px;
          margin-top: -10px;
          font-size: 22px;
          font-weight: bold;
          color: #363942;
          line-height: 36px;
          overflow: hidden;
          text-overflow: ellipsis ;
          -webkit-line-clamp: 2;
          -webkit-box-orient: vertical;
          word-break: break-all;
        }
        .gray-area {
          width: 755px;
          height: 85px;
          margin-top: 30px;
          background: #F2F3F8;
          padding: 12px 20px;
          box-sizing: border-box;
          p {
            width: 100%;
            font-size: 14px;
            font-weight: bold;
            color: #363942;
            line-height: 25px;
            overflow: hidden;
            text-overflow: ellipsis ;
            white-space: nowrap;
          }
          .bottom {
            font-weight: 400;
            color: #A2A8B6;
            margin-top: 20px;
            span {
              color:#EA5504;
              font-size: 16px;
              font-weight: bold;
              cursor: pointer;
            }
            span:hover {
              color:#EA5504;
            }
          }
        }
      }
      .toJoin {
        width: 300px;
        height: 40px;
        line-height: 40px;
        background-color: #EA5504;
        border-radius: 10px;
        font-size: 18px;
        text-align: center;
        color: #FFFFFF;
        cursor: pointer;
        margin: 50px auto 0 auto;
      }
      .toJoin:hover {
        opacity: 0.8;
      }
    }
  }
  .tutor {
    margin-top: 20px;
    font-size: 36px;
    font-family: YouSheBiaoTiHei;
    font-weight: 400;
    color: #333333;
  }
  .tutor-item {
    width: 1200px;
    height: 150px;
    box-sizing: border-box;
    padding: 15px 20px;
    background: #FFFFFF;
    border-radius: 5px;
    margin-top: 20px;
    img {
      display: inline-block;
      width: 120px;
      height: 120px;
      vertical-align: top;
    }
    .tutor-detail {
      display: inline-block;
      width: 1010px;
      line-height: 25px;
      margin-left: 30px;
      font-size: 16px;
      font-weight: 400;
      color: #999999;
      span {
        font-size: 24px;
        font-weight: bold;
        color: #333333;
        cursor: pointer;
      }
      span:hover {
        color: #EA5504;
      }
    }
  }
}

</style>
